import { render, staticRenderFns } from "./NormalSearchNav515.vue?vue&type=template&id=c20648b6&scoped=true"
import script from "./NormalSearchNav515.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav515.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20648b6",
  null
  
)

export default component.exports